module.exports = __webpack_public_path__ + "static/media/wings video.efa8998d.png";